import { render, staticRenderFns } from "./ContactSideInfo.vue?vue&type=template&id=e4cb9bcc"
import script from "./ContactSideInfo.vue?vue&type=script&lang=js"
export * from "./ContactSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports